import {
    faSearch,
    faChevronRight,
    faChevronDown,
    faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import DashboardLeftMenu from '../../DashboardLeftMenu';
import DashboardHeader from '../../../Header/DashboardHeader';
import DashboardFooter from '../../../Footer/AdminFooter';
import Axios from '../../../../axios/Axios';
import { HOST_URL, NODE_HOST_URL } from '../../api/Api';
import whatsappBackgroundImage from '../../../Dashboard/assets/img/whatsappBackgroundImage.jpeg'
import Select from "react-select";
import Spining from '../../../UI/Spining/Spining';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { WHATSAPP_TEMPLATE_LIST } from '../../../../constants/ServiceConstants';
import pdf from "../../assets/img/pdfmediagallery.png"
import styles from "../components/ActiveTabs.module.css"
import { handleUserLog } from "../../../Utils/Utils";

const TemplateLibrary = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;
    const history = useHistory();
    const [openMenu, setOpenMenu] = useState({
        tempcategory: true,
        industry: true,
        topic: true,
        useCase: true
    });
    const [industrySelected, setIndustrySelected] = useState({ category: '', value: '' });
    const [topicSelected, setTopicSelected] = useState({ category: '', value: '' });
    const [usecaseSelected, setUsecaseSelected] = useState({ category: '', value: '' });
    const [myTemplateSelected, setMyTemplateSelected] = useState({ category: '', value: '' });
    const [metaTemplateSelected, setMetaTemplateSelected] = useState({ category: '', value: '' });
    const [templateData, setTemplateData] = useState([]);
    const [next, setNext] = useState('');
    const [previous, setPrevious] = useState('');
    const [language, setLanguage] = useState({ label: "English", value: "en" });
    const [myTemplatelanguage, setMyTemplateLanguage] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState([]);
    const [searchData, setSearchData] = useState('')
    const [loading, setLoading] = useState(false);
    const [route, setRoute] = useState('')
    const [templateLibraryOption, setTemplateLibraryOption] = useState(true);
    const [myTemplateOption, setMyTemplateOption] = useState(false);
    const [whatsappTemplateList, setWhatsappTemplateList] = useState([]);
    const [searchMyTemplateData, setSearchMyTemplateData] = useState('')
    const [originalWhatsappTemplateList, setOriginalWhatsappTemplateList] = useState([]);


    useEffect(() => {
        Content();
    }, [industrySelected, topicSelected, usecaseSelected, language]);

    useEffect(() => {
        RetrieveLanguage();
        getRoute();
    }, []);

    useEffect(() => {
        getWhatsaAppTemplateList();
    }, [myTemplateSelected])

    const getWhatsaAppTemplateList = async () => {
        // this.setState({ setIsLoading: true });
        setLoading(true)
        try {
            const { data } = await Axios.post(WHATSAPP_TEMPLATE_LIST, {
                token: token,
                user_id: user_id,
                method: "retrieve",
            });
            if (data.success === true) {

                const temp_list = data.data.map((list) => {
                    if (list?.temp_header || list?.temp_button) {
                        const new_temp_header = JSON.parse(list.temp_header);
                        const new_temp_button = JSON.parse(list.temp_button);
                        list.temp_header = new_temp_header
                        list.temp_button = new_temp_button
                        return list;
                    }
                    return list;
                })
                if (myTemplateSelected && myTemplateSelected.value) {
                    const filterData = temp_list.filter(x => x.temp_category === myTemplateSelected.value);
                    setWhatsappTemplateList(filterData);
                    setOriginalWhatsappTemplateList(filterData);
                }
                else {
                    setWhatsappTemplateList(temp_list);
                    setOriginalWhatsappTemplateList(temp_list);
                }

                setLoading(false);
            } else {
                setLoading(false)
            }
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
        setLoading(false)
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    const toggleMenu = (menu) => {
        setOpenMenu((prev) => ({
            ...prev,
            [menu]: !prev[menu]
        }));
    };

    const RetrieveLanguage = async () => {
        try {
            let { data } = await Axios.post(
                `${HOST_URL}/whatsapp_template_language.php`,
                {
                    user_id: user_id,
                    method: "retrieve",
                    id: null,
                    token: token
                }
            );

            if (data.success) {
                const newData = data.data.map((x) => ({
                    label: x.title,
                    value: x.code,
                }));
                setSelectedLanguage(newData);
            }
        } catch (error) {
            console.log(error);
        }
    };


    const handleLanguageChange = (selectedOption) => {
        setLanguage(selectedOption)
    };

    const handleMyTemplateLanguageChange = (selectedOption) => {
        let inputValue = selectedOption
        setMyTemplateLanguage(selectedOption)

        if (inputValue !== "") {
            const filteredData = originalWhatsappTemplateList.filter(x =>
                x.temp_language.toLowerCase().includes(inputValue.value.toLowerCase())
            );
            setWhatsappTemplateList(filteredData);
        } else {
            setWhatsappTemplateList(originalWhatsappTemplateList);
        }
    }

    const handleCheckboxIndustryChange = (category, value) => {
        setIndustrySelected((prev) =>
            prev.value === value ? { category: '', value: '' } : { category, value }
        );
    };

    const handleCheckboxTopicChange = (category, value) => {
        setTopicSelected((prev) =>
            prev.value === value ? { category: '', value: '' } : { category, value }
        );
    };

    const handleCheckboxUsecaseChange = (category, value) => {
        setUsecaseSelected((prev) =>
            prev.value === value ? { category: '', value: '' } : { category, value }
        );
    };

    const handleMyTemplateCheckboxChange = (category, value) => {
        setMyTemplateSelected((prev) =>
            prev.value === value ? { category: '', value: '' } : { category, value }
        );
    };

    const handleMetaTemplateCheckboxChange = (category, value) => {
        setMetaTemplateSelected((prev) =>
            prev.value === value ? { category: '', value: '' } : { category, value }
        );
    };

    const renderCheckboxIndustryItem = (id, label, category) => (
        <div
            className="form-check mb-1"
            onClick={(e) => e.stopPropagation()} // Prevent toggle
        >
            <input
                className="form-check-input"
                type="checkbox"
                id={id}
                checked={industrySelected.value === label}
                onChange={() => handleCheckboxIndustryChange(category, label)}
            />
            <label className="form-check-label" htmlFor={id}>
                {label}
            </label>
        </div>
    );

    const renderCheckboxTopicItem = (id, label, category) => (
        <div
            className="form-check mb-1"
            onClick={(e) => e.stopPropagation()} // Prevent toggle
        >
            <input
                className="form-check-input"
                type="checkbox"
                id={id}
                checked={topicSelected.value === label}
                onChange={() => handleCheckboxTopicChange(category, label)}
            />
            <label className="form-check-label" htmlFor={id}>
                {label}
            </label>
        </div>
    );

    const renderCheckboxUsecaseItem = (id, label, category) => (
        <div
            className="form-check mb-1"
            onClick={(e) => e.stopPropagation()} // Prevent toggle
        >
            <input
                className="form-check-input"
                type="checkbox"
                id={id}
                checked={usecaseSelected.value === label}
                onChange={() => handleCheckboxUsecaseChange(category, label)}
            />
            <label className="form-check-label" htmlFor={id}>
                {label}
            </label>
        </div>
    );

    const renderCheckboxMyTemplateItem = (id, label, category) => (
        <div
            className="form-check mb-1"
            onClick={(e) => e.stopPropagation()} // Prevent toggle
        >
            <input
                className="form-check-input"
                type="checkbox"
                id={id}
                checked={myTemplateSelected.value === label}
                onChange={() => handleMyTemplateCheckboxChange(category, label)}
            />
            <label className="form-check-label" htmlFor={id}>
                {label}
            </label>
        </div>
    );

    const renderCheckboxMetaTemplateItem = (id, label, category) => (
        <div
            className="form-check mb-1"
            onClick={(e) => e.stopPropagation()} // Prevent toggle
        >
            <input
                className="form-check-input"
                type="checkbox"
                id={id}
                checked={metaTemplateSelected.value === label}
                onChange={() => handleMetaTemplateCheckboxChange(category, label)}
            />
            <label className="form-check-label" htmlFor={id}>
                {label}
            </label>
        </div>
    );

    const handleSearchData = (e) => {
        setSearchData(e.target.value)
    }

    const Content = async () => {
        setLoading(true);
        let paramData = {
            user_id: user_id,
            token: token,
            method: "temp_library",
            limit: 6,
            industry: industrySelected.value,
            topic: topicSelected.value,
            usecase: usecaseSelected.value,
            language: language.value,
            name: searchData
        }

        try {
            let { data } = await Axios.post(`${NODE_HOST_URL}/whatsapp_temp`, paramData)
            if (data.success) {
                console.log(data.data.template)
                setTemplateData(data?.data?.template);
                setNext(data.data.page.next_page);
                setPrevious(data.data.page.previous_page);
            }
        } catch (error) {
            console.log(error)
        }
        setLoading(false);
    }

    const ChangePages = async (stage) => {
        setLoading(true)
        let paramData
        if (stage === "before") {
            paramData = {
                user_id: user_id,
                token: token,
                method: "temp_library",
                limit: 6,
                before: previous,
                industry: industrySelected.value,
                topic: topicSelected.value,
                usecase: usecaseSelected.value,
                language: language.value,
                name: searchData
            }
        }
        if (stage === "after") {
            paramData = {
                user_id: user_id,
                token: token,
                method: "temp_library",
                limit: 6,
                after: next,
                industry: industrySelected.value,
                topic: topicSelected.value,
                usecase: usecaseSelected.value,
                language: language.value,
                searchkey: searchData
            }
        }

        try {
            let { data } = await Axios.post(`${NODE_HOST_URL}/whatsapp_temp`, paramData)
            if (data.success) {
                setTemplateData(data.data.template);
                setNext(data.data.page.next_page);
                setPrevious(data.data.page.previous_page);
            }
        } catch (error) {
            console.log(error)
        }
        setLoading(false)
    }

    const getRoute = async () => {
        try {
            let paramData = {
                user_id: user_id,
                method: "retrieve",
                token: token
            }
            let { data } = await Axios.post(`${HOST_URL}/get_user_route.php`, paramData)
            if (data.success) {
                setRoute(data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const SendToWhatsappTemplate = (id, temp_category) => {
        handleUserLog("", "clicked_use_template", "whatsapp", "User click on Use Template button", "whatsapp_template_library", "", { template_id: id, category: temp_category });
        if ((route === 25 || route === 36 || route === 41) && (temp_category === "Authentication" || temp_category === "AUTHENTICATION")) {
            history.push(`/dashboard/create-whatsapp-template-authentication?id=${id}`);
        } else if (route === 36 || route === 41) {
            history.push(`/dashboard/create-whatsapp-template-new?id=${id}`);
        } else {
            history.push(`/dashboard/create-whatsapp-template?id=${id}`);
        }
    }

    // console.log(route);



    const handleTemplateLibraryChange = () => {
        handleUserLog("", "clicked_template_library_tab", "whatsapp", "User click on Template Library tab", "whatsapp_template_library", "", "");
        setTemplateLibraryOption(true)
        setMyTemplateOption(false)
    }

    const handleMyTemplateChange = () => {
        handleUserLog("", "clicked_my_templates_tab", "whatsapp", "User click on My Templates tab", "whatsapp_template_library", "", "");
        setMyTemplateOption(true)
        setTemplateLibraryOption(false)
    }

    const handleMyTemplateData = (e) => {
        const inputValue = e.target.value;
        setSearchMyTemplateData(inputValue);

        if (inputValue !== "") {
            const filteredData = originalWhatsappTemplateList.filter(x =>
                x.temp_name.toLowerCase().includes(inputValue.toLowerCase())
            );
            setWhatsappTemplateList(filteredData);
        } else {
            setWhatsappTemplateList(originalWhatsappTemplateList);
        }
    };

    // console.log(whatsappTemplateList)

    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3><strong>Template Library</strong></h3>
                            </div>
                        </div>

                        <div className='row m-1'>
                            <div className='col-md-9'>
                                <div className="card mb-3">
                                    <div className="card-body">
                                        {templateLibraryOption &&
                                            <div className="row m-1">
                                                <div className="col-9">
                                                    <div className="input-group float-md-right">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">
                                                                <FontAwesomeIcon icon={faSearch} />
                                                            </span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            id="searchInput"
                                                            name="searchdata"
                                                            value={searchData}
                                                            onChange={handleSearchData}
                                                            className="form-control"
                                                            placeholder="Search"
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-3'>
                                                    <div className="input-group mb-3 drop-down-icons">
                                                        <Select
                                                            onChange={handleLanguageChange}
                                                            options={selectedLanguage}
                                                            value={language}
                                                            isSearchable={true}
                                                            placeholder="Select Language"
                                                            styles={customStyles}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}

                                        {myTemplateOption &&
                                            <div className='row m-3'>
                                                <div className='col-9'>
                                                    <div className="input-group float-md-right">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text">
                                                                <FontAwesomeIcon icon={faSearch} />
                                                            </span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            id="searchInput"
                                                            name="searchdata"
                                                            value={searchMyTemplateData}
                                                            onChange={handleMyTemplateData}
                                                            className="form-control"
                                                            placeholder="Search"
                                                        />
                                                    </div>
                                                </div>


                                                <div className='col-3'>
                                                    <div className="input-group mb-3 drop-down-icons">
                                                        <Select
                                                            onChange={handleMyTemplateLanguageChange}
                                                            options={selectedLanguage}
                                                            value={myTemplatelanguage}
                                                            isSearchable={true}
                                                            placeholder="Select Language"
                                                            styles={customStyles}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}

                                        <ul className={`d-flex align-items-center list-unstyled ${styles.navTabs}`}>
                                            <li
                                                className={`me-4 px-3 py-2 ${templateLibraryOption ? styles.activeTab : styles.inactiveTab}`}
                                                role="button"
                                                onClick={() => handleTemplateLibraryChange()}
                                            >
                                                Template Library
                                            </li>
                                            <li
                                                className={`me-4 px-3 py-2 ${myTemplateOption ? styles.activeTab : styles.inactiveTab}`}
                                                role="button"
                                                onClick={() => handleMyTemplateChange()}
                                            >
                                                My Templates
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="row">
                                    {/* Right Content */}
                                    {templateLibraryOption &&
                                        <div className="col-md-12">
                                            <div className="card">
                                                {loading && <Spining />}
                                                <div className="card-body">
                                                    {templateData.reduce((rows, item, index) => {
                                                        if (index % 2 === 0) {
                                                            rows.push([item]);
                                                        } else {
                                                            rows[rows.length - 1].push(item);
                                                        }
                                                        return rows;
                                                    }, []).map((row, rowIndex) => (
                                                        <div className="row mb-3" key={rowIndex}>
                                                            {row.map((item, colIndex) => (
                                                                <div className="col-12 col-md-6 mb-3" key={colIndex}>
                                                                    <div className="card h-100 border-primary">
                                                                        <div
                                                                            className="card-img-top d-flex align-items-center justify-content-center bg-light"
                                                                            style={{
                                                                                height: '350px',
                                                                                backgroundImage: `url(${whatsappBackgroundImage})`,
                                                                                backgroundSize: 'cover',
                                                                                backgroundPosition: 'center'
                                                                            }}
                                                                        >
                                                                            <div className='card m-5'>
                                                                                <div className='card-header'>
                                                                                    <h6>{item.header}</h6>
                                                                                </div>

                                                                                <div className='card-body'>
                                                                                    <span className="text-muted">{item.body}</span>
                                                                                </div>

                                                                                {/* Category at bottom like header */}
                                                                                <div className='card-footer text-center'>
                                                                                    <strong>{item.category}</strong>
                                                                                </div>



                                                                                {item?.buttons?.length > 0 && (
                                                                                    <>
                                                                                        <hr />
                                                                                        <span className='m-3 text-center d-block'>
                                                                                            <a
                                                                                                target='_blank'
                                                                                                rel='noopener noreferrer'
                                                                                                style={{ color: "#2DA0ED" }}
                                                                                                href={item.buttons[0].url}
                                                                                            >
                                                                                                <FontAwesomeIcon icon={faExternalLinkAlt} />
                                                                                                <span className='ml-2'>{item.buttons[0].text}</span>
                                                                                            </a>
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="card-body p-2 d-flex justify-content-between align-items-center">
                                                                            <p className="card-text mb-0">{item.name}</p>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm"
                                                                                style={{ backgroundColor: "#4ec9b0", color: "white", padding: "7px" }}
                                                                                onClick={() => SendToWhatsappTemplate(item.id, item.category)}
                                                                            >
                                                                                Use Template
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))}



                                                    {templateData.length > 0 &&
                                                        <div className='row'>
                                                            <div className='col-6'>
                                                                <button type="button" onClick={() => ChangePages("before")} style={{ backgroundColor: "#4ec9b0", color: "white" }} className="btn btn">Previous</button>
                                                            </div>
                                                            <div className='col-6'>
                                                                <button type="button" onClick={() => ChangePages("after")} style={{ backgroundColor: "#4ec9b0", color: "white" }} className="btn btn float-right">Next</button>
                                                            </div>
                                                        </div>}

                                                </div>
                                            </div>
                                        </div>}

                                    {myTemplateOption &&
                                        <div className="col-md-12">
                                            <div className="card">
                                                {loading && <Spining />}
                                                <div className="card-body">
                                                    {whatsappTemplateList.reduce((rows, item, index) => {
                                                        if (index % 2 === 0) {
                                                            rows.push([item]);
                                                        } else {
                                                            rows[rows.length - 1].push(item);
                                                        }
                                                        return rows;
                                                    }, []).map((row, rowIndex) => (
                                                        <div className="row mb-3" key={rowIndex}>
                                                            {row.map((item, colIndex) => (
                                                                <div className="col-12 col-md-6 mb-3" key={colIndex}>
                                                                    <div className="card h-100 border-primary">
                                                                        <div
                                                                            className="card-img-top d-flex align-items-center justify-content-center bg-light"
                                                                            style={{
                                                                                height: '350px',
                                                                                backgroundImage: `url(${whatsappBackgroundImage})`,
                                                                                backgroundSize: 'cover',
                                                                                backgroundPosition: 'center',
                                                                                overflowY: "auto",

                                                                            }}
                                                                        >
                                                                            <div className='card m-5'>
                                                                                <div className='card-header'>
                                                                                    <h6>{item.temp_category}</h6>
                                                                                </div>
                                                                                <div className="card-body">
                                                                                    {item.temp_type === "Media" ? (
                                                                                        <>
                                                                                            {item.temp_header?.TemplateType === "image" ? (
                                                                                                <img
                                                                                                    src={item.temp_header.image}
                                                                                                    className="card-img-top"
                                                                                                    alt="Media Image"
                                                                                                    style={{ height: '150px', objectFit: 'cover' }}
                                                                                                />
                                                                                            ) : item.temp_header?.TemplateType === "video" ? (
                                                                                                <video
                                                                                                    src={item.temp_header.video}
                                                                                                    className="card-img-top"
                                                                                                    controls
                                                                                                    style={{ height: '150px', objectFit: 'cover' }}
                                                                                                />
                                                                                            ) : (
                                                                                                <div
                                                                                                    className="card-img-top d-flex align-items-center justify-content-center bg-light"
                                                                                                    style={{ height: '150px' }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={pdf}
                                                                                                        alt="Document Preview"
                                                                                                        style={{ height: '100px', objectFit: 'contain' }}
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        <span className="text-muted">{item.temp_body}</span>
                                                                                    )}
                                                                                </div>

                                                                                {/* <hr /> */}
                                                                                {/* <span className='m-3 text-center'>
                                                                            {item?.temp_button?.map((button) => {
                                                                                return (
                                                                                    <a target='_blank' rel="noopener noreferrer" style={{ color: "#2DA0ED" }} href={"item.buttons[0].url"}>
                                                                                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                                                                                        <span className='ml-2'>{button?.text}</span>
                                                                                    </a>
                                                                                )
                                                                            })}
                                                                        </span> */}
                                                                            </div>
                                                                        </div>
                                                                        <div className="card-body p-2 d-flex justify-content-between align-items-center">
                                                                            <p className="card-text mb-0">{item.temp_name}</p>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm"
                                                                                style={{ backgroundColor: "#4ec9b0", color: "white", padding: "7px" }}
                                                                                onClick={() => SendToWhatsappTemplate(item.id, item.temp_category)}
                                                                            >
                                                                                Use Template
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))}



                                                    {templateData.length > 0 &&
                                                        <div className='row'>
                                                            <div className='col-6'>
                                                                <button type="button" onClick={() => ChangePages("before")} style={{ backgroundColor: "#4ec9b0", color: "white" }} className="btn btn">Previous</button>
                                                            </div>
                                                            <div className='col-6'>
                                                                <button type="button" onClick={() => ChangePages("after")} style={{ backgroundColor: "#4ec9b0", color: "white" }} className="btn btn float-right">Next</button>
                                                            </div>
                                                        </div>}

                                                </div>
                                            </div>
                                        </div>}
                                </div>




                            </div>

                            <div className="col-md-3 mb-3">
                                <div className="card">
                                    <div className="card-header bg-primary text-white">
                                        <span>Filters</span></div>
                                    {templateLibraryOption &&
                                        <ul className="list-group list-group-flush">


                                            <li className="list-group-item" onClick={() => toggleMenu('tempcategory')} style={{ cursor: 'pointer' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <strong>Template Category</strong>
                                                    <FontAwesomeIcon icon={openMenu.tempcategory ? faChevronDown : faChevronRight} />
                                                </div>
                                                {openMenu.tempcategory && (
                                                    <div className="mt-2 ms-2">
                                                        {renderCheckboxMetaTemplateItem('myTemplate-marketing', 'Marketing', 'myTemplate')}
                                                        {renderCheckboxMetaTemplateItem('myTemplate-utility', 'Utility', 'myTemplate')}
                                                        {renderCheckboxMetaTemplateItem('myTemplate-authentication', 'Authentication', 'myTemplate')}
                                                    </div>
                                                )}
                                            </li>


                                            <li className="list-group-item" onClick={() => toggleMenu('industry')} style={{ cursor: 'pointer' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <strong>Industry</strong>
                                                    <FontAwesomeIcon icon={openMenu.industry ? faChevronDown : faChevronRight} />
                                                </div>
                                                {openMenu.industry && (
                                                    <div className="mt-2 ms-2">
                                                        {renderCheckboxIndustryItem('industry-ecommerce', 'E_COMMERCE', 'industry')}
                                                        {renderCheckboxIndustryItem('industry-financial', 'FINANCIAL_SERVICES', 'industry')}
                                                    </div>
                                                )}
                                            </li>

                                            <li className="list-group-item" onClick={() => toggleMenu('topic')} style={{ cursor: 'pointer' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <strong>Topic</strong>
                                                    <FontAwesomeIcon icon={openMenu.topic ? faChevronDown : faChevronRight} />
                                                </div>
                                                {openMenu.topic && (
                                                    <div className="mt-2 ms-2">
                                                        {renderCheckboxTopicItem('topic-account', 'ACCOUNT_UPDATE', 'topic')}
                                                        {renderCheckboxTopicItem('topic-feedback', 'CUSTOMER_FEEDBACK', 'topic')}
                                                        {renderCheckboxTopicItem('topic-order', 'ORDER_MANAGEMENT', 'topic')}
                                                        {renderCheckboxTopicItem('topic-payments', 'PAYMENTS', 'topic')}
                                                    </div>
                                                )}
                                            </li>

                                            <li className="list-group-item" onClick={() => toggleMenu('useCase')} style={{ cursor: 'pointer' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <strong>Use Case</strong>
                                                    <FontAwesomeIcon icon={openMenu.useCase ? faChevronDown : faChevronRight} />
                                                </div>
                                                {openMenu.useCase && (
                                                    <div className="mt-2 ms-2">
                                                        {[
                                                            'ACCOUNT_CREATION_CONFIRMATION',
                                                            'PAYMENT_DUE_REMINDER',
                                                            'FEEDBACK_SURVEY',
                                                            'PAYMENT_ACTION_REQUIRED',
                                                            'SHIPMENT_CONFIRMATION',
                                                            'PAYMENT_OVERDUE',
                                                            'DELIVERY_UPDATE',
                                                            'PAYMENT_CONFIRMATION',
                                                            'ORDER_DELAY',
                                                            'FRAUD_ALERT',
                                                            'DELIVERY_FAILED',
                                                            'AUTO_PAY_REMINDER',
                                                            'DELIVERY_CONFIRMATION',
                                                            'PAYMENT_SCHEDULED',
                                                            'ORDER_PICK_UP',
                                                            'PAYMENT_REJECT_FAIL',
                                                            'ORDER_ACTION_NEEDED',
                                                            'STATEMENT_AVAILABLE',
                                                            'ORDER_CONFIRMATION',
                                                            'LOW_BALANCE_WARNING',
                                                            'ORDER_OR_TRANSACTION_CANCEL',
                                                            'RECEIPT_ATTACHMENT',
                                                            'RETURN_CONFIRMATION',
                                                            'STATEMENT_ATTACHMENT',
                                                            'TRANSACTION_ALERT'
                                                        ].map((label, index) =>
                                                            renderCheckboxUsecaseItem(`usecase-${index}`, label, 'useCase')
                                                        )}
                                                    </div>
                                                )}
                                            </li>

                                        </ul>}

                                    {myTemplateOption &&
                                        <ul className="list-group list-group-flush">

                                            <li className="list-group-item" onClick={() => toggleMenu('industry')} style={{ cursor: 'pointer' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <strong>Filters</strong>
                                                    <FontAwesomeIcon icon={openMenu.industry ? faChevronDown : faChevronRight} />
                                                </div>
                                                {openMenu.industry && (
                                                    <div className="mt-2 ms-2">
                                                        {renderCheckboxMyTemplateItem('myTemplate-marketing', 'Marketing', 'myTemplate')}
                                                        {renderCheckboxMyTemplateItem('myTemplate-utility', 'Utility', 'myTemplate')}
                                                        {renderCheckboxMyTemplateItem('myTemplate-authentication', 'Authentication', 'myTemplate')}
                                                    </div>
                                                )}
                                            </li>
                                        </ul>}
                                </div>
                            </div>
                        </div>


                    </div>
                </main>
                <DashboardFooter />
            </div>
        </div>
    );
};

export default TemplateLibrary;
